import {useEffect} from 'react';

import {useUserDynamicConfigWithLoading} from '../../../useDynamicConfig';
import {
  getAmbientResponsivenessSamplingOptions,
  initializeAmbientResponsivenessSampling,
} from './ambientSampler';
import {initializeCriticalWorkflowPainWindowMonitoring} from './observer';

export const usePainWindowMonitoring = () => {
  const {config, loading} = useUserDynamicConfigWithLoading(
    'perf_observer_ambient_sampling'
  );
  const ambientSamplingOptions = loading
    ? undefined
    : getAmbientResponsivenessSamplingOptions(config);
  const intervalBaselineMs = ambientSamplingOptions?.intervalBaselineMs;
  const observationDurationMs = ambientSamplingOptions?.observationDurationMs;

  useEffect(() => initializeCriticalWorkflowPainWindowMonitoring(), []);

  useEffect(() => {
    if (intervalBaselineMs == null || observationDurationMs == null) {
      return;
    }
    return initializeAmbientResponsivenessSampling({
      intervalBaselineMs,
      observationDurationMs,
    });
  }, [intervalBaselineMs, observationDurationMs]);
};
